module.exports = __webpack_public_path__ + "img/account.9b598de4.svg";